import { Routes, Route, Navigate } from 'react-router-dom'
import Sidebar from './components/Sidebar'
import DashboardPage from './pages/dashboard/DashboardPage'
import UsersPage from './pages/users/UsersPage'
import PetsPage from './pages/pets/PetsPage'
import SubscriptionsPage from './pages/subscriptions/SubscriptionsPage'
import ContentPage from './pages/content/ContentPage'
import ReferralsPage from './pages/referrals/ReferralsPage'
import SupportPage from './pages/support/SupportPage'
import AnalyticsPage from './pages/analytics/AnalyticsPage'
import SettingsPage from './pages/settings/SettingsPage'
import PartnersPage from './pages/partners/PartnersPage'
import CareMarketplacePage from './pages/care-marketplace/CareMarketplacePage'
import VetClinicsPage from './pages/vet-clinics/VetClinicsPage'

/**
 * Main App Layout with sidebar navigation
 * Renders routes for all admin dashboard pages
 */
export default function App() {
  return (
    <div className="flex h-screen bg-pawssible-slate-50">
      {/* Sidebar Navigation */}
      <Sidebar />

      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto">
        <div className="p-8">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/pets" element={<PetsPage />} />
            <Route path="/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/content" element={<ContentPage />} />
            <Route path="/referrals" element={<ReferralsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/care-marketplace" element={<CareMarketplacePage />} />
            <Route path="/vet-clinics" element={<VetClinicsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  )
}
